import type { PrimitiveAtom } from 'jotai';
import { atom } from 'jotai';

import type { Posts } from '@/components/pages/giveaway-picker/Types/types';

export const selectedPostAtom = atom(null) as PrimitiveAtom<Posts>;
